import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What is a portfolio?",
    category: "Technology",
    description:
      "A portfolio is a collection of investments including stocks, bonds, mutual funds, and ETFs. A diversified portfolio reduces risk and helps investors balance returns across multiple asset classes.",
  },
  {
    title: "What is a Demat account?",
    category: "Trending",
    description:
      "A Demat account electronically stores your shares, similar to a digital wallet for stocks. You need a Demat account and a trading account to buy, sell, and hold equities safely.",
  },
  {
    title: "Is stock market safe for beginners?",
    category: "Design",
    description:
      "Yes, the stock market is safe for beginners if they learn basics, invest gradually, diversify, and avoid emotional decisions. Starting with mutual funds or index funds helps reduce risk.",
  },
  {
    title: "What is risk in the stock market?",
    category: "Design",
    description:
      "Stock market risk refers to the possibility of losing money due to unexpected price changes. Risks come from market volatility, economic shifts, poor company performance, and global uncertainties.",
  },
  {
    title: "What are stocks or shares?",
    category: "Design",
    description:
      "Stocks represent ownership in a company. When you buy shares, you own a portion of that business and can benefit from dividends, price growth, and long-term appreciation depending on company performance.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
